import { Breadcrumb } from "@/components/ui/breadcrumb";
import { ReconciliationExceptionsStateView } from "@/features/oversight/reconciliation-exceptions";

// Deferred (page-delivery-pipeline.md G6, 2026-09-23). alloy-reconflow-service is a README,
// not a module: no pom.xml, no src/, no migrations. See
// context/page_pipeline/BACKEND_GAPS.md rows 20-23.
//
// The page renders the exception queue's real state surface with the
// `unavailableReason` set, so the queue's loading/empty/error/list branches are
// implemented and pinned by tests while the honest thing on screen stays "not
// available yet" — never a fabricated "No open exceptions", which would claim a
// reconciliation service answered when none exists.
export default function ReconciliationExceptionsPage() {
  return (
    <div>
      <Breadcrumb items={[{ label: "Reconciliation", href: "/reconciliation" }, { label: "Exception Queue" }]} />
      <ReconciliationExceptionsStateView
        exceptions={null}
        loading={false}
        error={null}
        unavailableReason="This is not available in your environment yet."
      />
    </div>
  );
}
